import { useQuery } from '@tanstack/react-query';
import { fetchPublicWarranty } from './apiAdapters';
import { mapWarrantyResult } from './mappers/warrantyMapper';

// Điểm duy nhất presentation gọi vào để lấy dữ liệu bảo hành. Cache, huỷ request khi đổi serial và
// retry đều do TanStack Query lo (mặc định chung ở core/network/queryClient.js).
export const useWarrantyQuery = (serial, { enabled = true } = {}) => {
  const query = useQuery({
    queryKey: ['publicWarranty', serial],
    queryFn: ({ signal }) => fetchPublicWarranty(serial, { signal }),
    select: mapWarrantyResult,
    enabled: enabled && !!serial,
  });

  return {
    data: query.data?.data ?? null,
    notFound: !!query.data?.notFound,
    error: query.error,
    loading: query.isFetching,
    refetch: query.refetch,
  };
};
